import React, {Component} from "react";
import App from "../App";
import AddButton from "../common/AddButton/AddButton";
import Loading from "../common/Loading/Loading"
import ProductsTable from "./components/ProductsTable";
import ProductsPagination from "./components/ProductsPagination";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button, Input, InputGroup, InputGroupAddon} from "reactstrap";
import "./Products.css";
import ProductService from "../services/product-service";
import ToastOptions from "../common/toast/toastr-config.js";
import history from "../history";
import toastr from "toastr";
import lodash from "lodash";
import AddProduct from "./addProduct";
import FilterDropDown from "../common/Filter/FilterDropDown";
import Permissions from "../authentication/Permissions";
import AuthorizationService from "../services/authorization-service";

export default class Products extends Component {
    mount = false;

    constructor(props) {
        super(props);
        this.state = {
            appSchemas: {},
            per_page: 25,
            page: 0,
            products: [],
            loading: true,
            search_query: "",
            search_status: null,
            sorting_field: "",
            sorting_order: 1,
            isUserProduct: false,
            queryParams: {},
            isInFocus: false,
            isTenantBasedChecked: false,
            isDialogLoading: false
        };
        this.debouncePagination = lodash.debounce(this.changePage, 100);
    }

    componentWillMount() {

        if (this.props.location.search !== "") {

            let searchQuery = this.props.location.search;
            const searchParams = searchQuery.replace("?", "").split("&").reduce(function (prev, curr, i, arr) {
                const parameter = curr.split("=");
                prev[decodeURIComponent(parameter[0])] = decodeURIComponent(parameter[1]);
                return prev;
            }, {});

            this.setState({
                search_status: (searchParams.status === "null") ? null : (searchParams.status === "true") ? true : false,
            });
        }
    }

    componentDidMount() {
        this.mount = true;

        if (this.props.location.search !== "") {

            let searchQuery = this.props.location.search;
            const searchParams = searchQuery.replace("?", "").split("&").reduce(function (prev, curr, i, arr) {
                const parameter = curr.split("=");
                prev[decodeURIComponent(parameter[0])] = decodeURIComponent(parameter[1]);
                return prev;
            }, {});

            this.setState({
                per_page: parseInt(searchParams.per_page, 10),
                page: parseInt(searchParams.page, 10),
                search_query: searchParams.keyword,
                search_status: (searchParams.status === "null") ? null : (searchParams.status === "true") ? true : false,
            }, () => this.fetchProducts());
        } else {
            history.replace("/products");
            this.fetchProducts();
        }
    }

    componentWillUnmount() {
        this.mount = false;
    }

    /**
     * In order to handle the situation where the user clicks on the Products link in the navigation pane, we want to reset the product list
     * I identified that when this link is clicked, the props.history.action is "PUSH", allowing me to identify a state when to reset the state.
     */
    componentWillReceiveProps(props) {
        if (props.history.action === "PUSH") {
            this.setState({
                search_query: "",
                search_status: null,
                sorting_field: "",
                sorting_order: 1
            }, this.fetchProducts)
        }
    }

    fetchProducts = async () => {
        if (this.mount) {
            this.setState({loading: true});
        }

        const params = {
            q: this.state.search_query.trim(),
            isActive: this.state.search_status,
            itemsPerPage: this.state.per_page,
            page: this.state.page,
        };

        const query = `?per_page=${params.itemsPerPage}&page=${params.page}&status=${params.isActive}&keyword=${params.q}`;
        history.replace(`${query}`);

        this.setState({queryParams: params});

        try {
            const products = await ProductService.getProductsByCriteria(params);
            if (this.mount) {
                this.setState({...products, loading: false});
            }
        } catch (error) {
            this.setState({loading: false});
            toastr.options = ToastOptions;
            toastr.error(error.message);
        }
    };

    handlePageChange = e => {
        this.debouncePagination(e.selected);
    };

    changePage = value => {
        if (value >= 0 && value < this.state.total_pages) {
            this.setState({page: value}, () => {
                this.fetchProducts();
            });
        }
    };

    handleStatusFilter = status => {
        status = status !== "all" ? status : ""
        this.setState({search_status: status, page: 0}, () => {
            this.fetchProducts();
        });
    };


    handleProductsTypeFilter = field => {
        field = field !== "all" ? field : ""
        this.setState({search_query: field, page: 0}, () => {
            this.fetchProducts();
        });
    };

    handleQueryChange = e => {
        if (e.target.value === "") {
            this.setState({search_query: "", page: 0}, () => this.fetchProducts());
        }
        this.setState({search_query: e.target.value});
    };

    handleKeyPressSearch = e => {
        if (e.key === "Enter") {
            this.setState({page: 0}, () => {
                this.fetchProducts();
            });
        }
    };

    handleSortColumn = () => {
    };




    onBlur = () => {
        this.setState({isInFocus: false});
    }

    onFocus = () => {
        this.setState({isInFocus: true});
    }

    render() {
        return (
            <App {...this.props}>
                <div className="products">
                    <h2>
                        Products
                        <span className="create">
                        {
                            AuthorizationService.hasPermission(Permissions.product.add) &&
                            <AddButton
                                name="Add Product"
                                handleCreateDialogToggle={() => {
                                    this.setState({isCreateProductDialogModalVisible: true})
                                }}
                            />
                        }
            </span>
                    </h2>
                    <AddProduct
                        isCreateProductDialogModalVisible={this.state.isCreateProductDialogModalVisible}
                        handleCancel={() => {
                            this.setState({isCreateProductDialogModalVisible: false})
                        }}
                    />
                    <div className="search-header">
                        <div className="search-bar">
                            <InputGroup>
                                <Input
                                    type="search"
                                    name="search"
                                    id="exampleSearch"
                                    placeholder="Search"
                                    value={this.state.search_query}
                                    onChange={this.handleQueryChange}
                                    onKeyPress={event => {
                                        this.handleKeyPressSearch(event);
                                    }}
                                    autoComplete="off"
                                    onFocus={this.onFocus}
                                    onBlur={this.onBlur}
                                />
                                <InputGroupAddon addonType="append">
                                    <FilterDropDown
                                        options={[
                                            {
                                                value: "all",
                                                label: "All"
                                            },
                                            {
                                                value: "user",
                                                label: "USER"
                                            },
                                            {
                                                value: "api",
                                                label: "API"
                                            },
                                        ]}
                                        selectedStatus={this.state.search_query}
                                        handleAccountsFilter={this.handleProductsTypeFilter}
                                    />
                                </InputGroupAddon>
                                <InputGroupAddon addonType="append">
                                    <FilterDropDown
                                        options={[
                                            {
                                                value: "all",
                                                label: "All"
                                            },
                                            {
                                                value: "true",
                                                label: "Active"
                                            },
                                            {
                                                value: "false",
                                                label: "Inactive"
                                            },
                                        ]}
                                        selectedStatus={this.state.search_status}
                                        handleAccountsFilter={this.handleStatusFilter}
                                    />

                                </InputGroupAddon>
                                <InputGroupAddon addonType="append">
                                    <Button
                                        color="success"
                                        onClick={() => {
                                            this.setState({page: 0}, () => {
                                                this.fetchProducts();
                                            });
                                        }}
                                    >
                                        <FontAwesomeIcon icon="search"/>
                                        &nbsp;Search
                                    </Button>
                                </InputGroupAddon>
                            </InputGroup>
                        </div>
                    </div>



                    <div className="search-body">
                        {this.state.loading ? (
                            <Loading/>
                        ) : (
                            <div>
                                <ProductsTable
                                    products={this.state.products}
                                    loading={this.state.loading}
                                    handleSortColumn={this.handleSortColumn}
                                    sortingField={this.state.sorting_field}
                                    sortingOrder={this.state.sorting_order}
                                    isInFocus={this.state.isInFocus}
                                />
                                <ProductsPagination
                                    page={this.state.page}
                                    total_pages={this.state.total_pages}
                                    start={this.state.start}
                                    end={this.state.end}
                                    total_products={this.state.total_products}
                                    handlePageChange={this.handlePageChange}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </App>
        );
    }
}



// WEBPACK FOOTER //
// ./src/products/Products.js